<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="2"
      :BackPath="'/Adaptive'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      v-if="!Bignav"
      :Type="false"
      :ImgUrl="'b01.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "About",
  data() {
    return {
      Bignav: false,
      Container: {
        title: "離線適應性治療",
        videosrc: "T06.mp4",

        list: [
          {
            body:
              "離線適應性放射治療（Offline Adaptive Radiotherapy, Offline ART）是一種高品質的放射治療技術，旨在提高治療的精確性和效果。與傳統放射治療不同，Offline ART透過在治療期間定期更新和調整治療計劃，以應對患者正常器官或腫瘤位置的變化。<br><br>" +
              "在治療期間，患者會定期接受3D影像導航，影像將用來評估腫瘤和周圍組織的變化。醫療團隊將依據患者腫瘤變化，重新設計或調整治療計劃，確保治療劑量精確地覆蓋腫瘤區域，同時盡量減少對健康組織的輻射損傷。<br><br>" +
              "Offline ART的優勢在於能夠動態地因應患者個體的生理變化及需求，提高治療的精度和效果，並減少副作用。特別適用於腫瘤位置變化較大或對放射治療敏感度高的癌症，如前列腺癌、頭頸癌和肺癌等。<br><br>" +
              "離線適應性放射治療透過持續監控和調整治療計劃，為患者提供個人精準化治療，有助於提高癌症治療的成功率和患者的生活質量。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
